<script>
import {useCatalogStore} from "@js/store/CatalogStore.js";
import CatalogFilter from "@js/components/Sections/Catalog/CatalogFilter.vue";
import IconX from "@js/components/Icons/IconX.vue";

export default {
    name: "CatalogMobileFilter",
    components: {IconX, CatalogFilter},
    setup() {
        const catalogStore = useCatalogStore()

        return {catalogStore}
    }
}
</script>

<template>
    <div>
        <div
            class="fixed inset-y-0 left-0 z-50 w-full bg-white shadow-lg transform transition-transform duration-300"
            :class="{ '-translate-x-full': !catalogStore.is_filter_open, 'translate-x-0': catalogStore.is_filter_open }">
            <div class="flex flex-col h-full p-4">
                <div>
                    <button @click.prevent="catalogStore.toggleFilter"
                            class="mb-4 rounded-md focus:outline-none float-end">
                     <IconX class="w-6 h-6"/>
<!--                        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5"-->
<!--                             stroke="currentColor" class="w-6 h-6">-->
<!--                            <path stroke-linecap="round" stroke-linejoin="round" d="M6 18L18 6M6 6l12 12"/>-->
<!--                        </svg>-->
                    </button>
                </div>
                <div class="flex-grow overflow-y-auto max-h-full">
                    <CatalogFilter/>
                </div>
                <div class="mt-auto">
                    <button type="button" @click.prevent="catalogStore.toggleFilter"
                       class="w-full mt-2 text-[#2D2D2D] border-2 border-indigo-600 font-medium rounded-full px-5 py-2.5 text-center me-2 mb-2">
                        Применить
                    </button>
                </div>
            </div>
        </div>

        <!-- Overlay -->
        <div
            v-if="catalogStore.is_filter_open"
            @click="catalogStore.toggleFilter"
            class="fixed inset-0 bg-black bg-opacity-50 z-40"
        ></div>
    </div>
</template>

<style scoped lang="scss">

</style>
